import { useRef } from 'react';
import {
    HotelApiCalls,
    HotelTicketCardRequest,
    roomAvailabilityRequest,
    roomAvailabilityReservationRequest,
    getReservationInfoRequest,
    GuestSaveRequest,
    searchStaticRequest,
    CardPaymentRequest,
    PnrRequest,
    ReservationStatusRequest,
    CancelReservationRequest,
    PromotionRequest,
} from './index.model';
import { getDetailRequest, searchLocationRequest } from './index.model';
import { AxiosResponse } from 'axios';
import { mappingHotelTicketCard } from './index.mapping';
import { axiosClient, elasticSearchClient } from 'services';

const useHotelService = (): HotelApiCalls => {
    const generateApiCalls = (): HotelApiCalls => {
        return {
            searchList: async (props: HotelTicketCardRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/search`, props);
                return mappingHotelTicketCard(response.data);
            },
            getDetailData: async (props: getDetailRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/detail`, props);
                return response.data;
            },
            roomAvailability: async (props: roomAvailabilityRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/availability`, props);
                return response.data;
            },
            roomAvailabilityReservation: async (props: roomAvailabilityReservationRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/reservation`, props);
                return response.data;
            },
            searchLocation: async (props: searchLocationRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/searchlocation`, props);
                return mappingHotelTicketCard(response.data);
            },
            searchStatic: async (props: searchStaticRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/searchstatic`, props);
                return response.data;
            },
            cardPaymentParam: async (props: CardPaymentRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/save_customer_and_room`, props);
                return response.data;
            },
            search: async (searchText: any) => {
                const response: any = await elasticSearchClient.get('hotels_v2/_search', {
                    params: {
                        source: JSON.stringify({
                            query: {
                                bool: {
                                    must: [
                                        {
                                            match_phrase: {
                                                IfActive: '1',
                                            },
                                        },
                                    ],
                                    should: [
                                        {
                                            multi_match: {
                                                query: searchText,
                                                type: 'phrase_prefix',
                                                fields: ['Name', 'NameEN', 'City', 'CityEN', 'District', 'DistrictEN'],
                                            },
                                        },
                                        {
                                            multi_match: {
                                                query: searchText,
                                                type: 'cross_fields',
                                                fields: ['Name', 'NameEN', 'City', 'CityEN', 'District', 'DistrictEN'],
                                                operator: 'and',
                                            },
                                        },
                                    ],
                                    minimum_should_match: 1,
                                },
                            },
                            sort: [
                                {
                                    Rating: {
                                        order: 'desc',
                                    },
                                },
                            ],
                            size: 20,
                        }),
                        source_content_type: 'application/json',
                    },
                });
                return response;
            },
            searchCode: async (searchCode: any) => {
                const response: any = await elasticSearchClient.get('hotels_v2/_search', {
                    params: {
                        source: JSON.stringify({
                            query: {
                                match_phrase: {
                                    ReferenceID: searchCode,
                                },
                            },
                            sort: [
                                {
                                    Rating: {
                                        order: 'desc',
                                    },
                                },
                            ],
                            size: 10,
                        }),
                        source_content_type: 'application/json',
                    },
                });
                return response;
            },
            searchPopularCities: async (list: any) => {
                const response: any = await elasticSearchClient.post('hotels_v2/_search', {
                    query: {
                        bool: {
                            must: [{ terms: { ReferenceID: list } }],
                        },
                    },
                });
                return response;
            },
            reservationInfo: async (props: getReservationInfoRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/getreservationinfo`, props);
                return response.data;
            },
            saveCustomer: async (props: GuestSaveRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/customer`, props);
                return response.data;
            },
            reservationControl: async (props: PnrRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/reservationcontrol`, props);
                return response.data;
            },
            reservationStatus: async (props: ReservationStatusRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/getreservationstatus`, props);
                return response.data;
            },
            cancelReservation: async (props: CancelReservationRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/cancelreservation`, props);
                return response.data;
            },
            getCurrenciesService: async () => {
                const response: AxiosResponse = await axiosClient.get(`/hotel/currencies`);
                return response;
            },
            applyPromotionCode: async (props: PromotionRequest) => {
                const response: AxiosResponse = await axiosClient.post(`/hotel/applyPromotionCode`, props);
                return response.data;
            },
        };
    };
    const callsRef = useRef<HotelApiCalls>(generateApiCalls());

    return callsRef.current;
};

export default useHotelService;
